import React from 'react';
import { SiriMainView } from './SiriMainView';

export const SiriMainCtrl = (props) => {
 
  
  return (
    <>
      <SiriMainView {...props}/>
    </>
  );
}




